import { Modal } from "react-bootstrap";
import ModalHead from "../../../../common/ui/ModalHead";

/* The first thing a member sees. No close button on purpose — "Continue as
   guest" is the dismissal, and saying so is clearer than a bare ✕ that leaves
   the customer wondering whether they just lost their rewards. */
export default function LoginModalPage(props) {
    return (
        <>
            <ModalHead title="Rewards" />
            <Modal.Body className="wo-loy__body">
                <div className="wo-loy__intro">
                    <span className="wo-loy__mark" aria-hidden="true">
                        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                             strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 3.5l2.6 5.3 5.9.85-4.25 4.15 1 5.85L12 16.9l-5.25 2.75 1-5.85L3.5 9.65l5.9-.85z" />
                        </svg>
                    </span>
                    <h3 className="wo-loy__head">Sign in to use your rewards</h3>
                    <p className="wo-loy__sub">
                        Your vouchers and points are tied to your mobile number. You can also
                        order without signing in.
                    </p>
                </div>

                <div className="wo-loy__actions">
                    <button type="button" className="wo-btn wo-btn--primary" onClick={props.handleClickLoginLoyaltyMobile}>Sign in</button>
                    <button type="button" className="wo-btn wo-btn--ghost" onClick={props.handleClickCloseLoyaltyModal}>Continue as guest</button>
                </div>
            </Modal.Body>
        </>
    )
}
